const orgCode = import.meta.env.VITE_KINDE_ORG_CODE;

export const kindeAuthOptions = orgCode ? { orgCode } : undefined;
